/**
 * Secondary buttons. Dark fills use light text so the pair stays above WCAG AA
 * (4.5:1) for normal-size labels.
 *
 * Light: #1f2937 on #f3f4f6.
 * Dark:  #f9fafb on #1f2937.
 */

const SECONDARY_BUTTON = {
  light: {
    background: '#f3f4f6',
    color: '#1f2937',
    border: '2px solid #d1d5db',
  },
  dark: {
    background: '#1f2937',
    color: '#f9fafb',
    border: '1px solid #9ca3af',
  },
};

function secondaryButtonStyle(isDark) {
  const colors = isDark ? SECONDARY_BUTTON.dark : SECONDARY_BUTTON.light;
  return {
    background: colors.background,
    color: colors.color,
    border: colors.border,
  };
}

module.exports = {
  SECONDARY_BUTTON,
  secondaryButtonStyle,
};
